import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  item: NewsItem;
  compact?: boolean;
}

export default function NewsCard({ item, compact = false }: NewsCardProps) {
  if (compact) {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex items-start gap-3 rounded-lg p-2 transition-colors hover:bg-background-100/70 cursor-pointer"
      >
        <span className="w-16 h-16 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img src={item.cover} alt={item.title} title={`${item.title}-榴莲视频资讯`} className="h-full w-full object-cover" />
        </span>
        <div className="min-w-0">
          <p className="dv-clamp-2 text-sm text-foreground-900 transition-colors group-hover:text-accent-500">
            {item.title}
          </p>
          <p className="mt-1 text-xs text-foreground-300">{item.date}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/60 bg-background-100/60 transition-colors hover:border-primary-400/60 cursor-pointer"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title}-榴莲视频影视资讯`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-background-50/80 px-2 py-0.5 text-xs text-accent-500 backdrop-blur-sm">
          {item.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="dv-clamp-2 text-base font-medium leading-snug text-foreground-950 transition-colors group-hover:text-accent-500">
          {item.title}
        </h3>
        <p className="mt-2 dv-clamp-2 text-sm leading-relaxed text-foreground-400">{item.summary}</p>
        <div className="mt-auto flex items-center gap-2 pt-4 text-xs text-foreground-300">
          <i className="ri-time-line"></i>
          {item.date}
          <span className="h-3 w-px bg-background-300"></span>
          {item.source}
        </div>
      </div>
    </Link>
  );
}